import OSS from 'ali-oss'
import { decryptAes } from './aes'

let ossClientInstance = null

const ossConfig = {
  region: process.env.OSS_REGION,
  bucket: process.env.OSS_BUCKET,
  encryptedAccessKeyId: process.env.OSS_ACCESS_KEY_ID,
  encryptedAccessKeySecret: process.env.OSS_ACCESS_KEY_SECRET,
  aesKey: process.env.OSS_AES_KEY
}

function resolveOssCredentials() {
  const { encryptedAccessKeyId, encryptedAccessKeySecret, aesKey } = ossConfig
  if (!encryptedAccessKeyId || !encryptedAccessKeySecret || !aesKey) {
    throw new Error('OSS 凭证未配置，请检查环境变量 OSS_*')
  }
  return {
    accessKeyId: decryptAes(encryptedAccessKeyId, aesKey),
    accessKeySecret: decryptAes(encryptedAccessKeySecret, aesKey)
  }
}

/**
 * 获取阿里云 OSS 客户端单例（运行时 AES 解密凭证，源码与打包产物中无明文 Key）
 */
export function getOssClient() {
  if (!ossClientInstance) {
    const { accessKeyId, accessKeySecret } = resolveOssCredentials()
    ossClientInstance = new OSS({
      region: ossConfig.region,
      bucket: ossConfig.bucket,
      accessKeyId,
      accessKeySecret
    })
  }
  return ossClientInstance
}

export default getOssClient



// WEBPACK FOOTER //
// ./src/utils/ossClient.js